import store from '@/store';
import RegistrationService from '@/api/RegistrationService';
import eventBus from './eventBus';

export const updateRegistration = async (slug: string) => {
  const registrationService = new RegistrationService();

  if (!store.getters['registration/getBusinessRegistration']) {
    await store.dispatch('registration/REFRESH_BUSINESS_REGISTRATION');
  }

  const shouldUpdateRegistration = store.getters[
    'registration/getBusinessRegistration'
  ].find((item: any) => item.slug === slug);

  if (shouldUpdateRegistration.businessSignupSteps[0].status === 'pending') {
    await registrationService.updateProgress(shouldUpdateRegistration.id, {
      status: 'seen'
    });
  }

  eventBus.$emit('refreshHomeTips');
  await store.dispatch('registration/REFRESH_BUSINESS_REGISTRATION');
};
